<template>
  <div class="animated fadeIn"> 
    <b-row> 
      <b-col sm="4">
        <input type="search" class="form-control sm-4" v-model="search" placeholder="Buscar por placa" />
      </b-col>
    </b-row>
    <br/>
    <b-row>
      <b-col sm="12">
      <GmapMap
        :center="{lat:-12.0509389, lng:-76.9974641}"
        :zoom="12"
        mapTypeId='roadmap'
        style="width: 100%; height: 100vh">

        <GmapMarker
          :key="index"
          v-for="(truck, index) in trucksFiltered"
          :position="{lat: truck.lat, lng: truck.lng}"
          :clickable="true"
          :draggable="false"
          @click="showInfo(truck)"
          :label="{
            text: `${truck.plate}`,
            color: 'black',
            fontSize: '10px',
          }">
          
          
        <!-- :icon="{ 
            url: require('@/assets/imgs/marker.png'), 
            size: {width: 100, height: 100, f: 'px', b: 'px'},
            scaledSize: {width: 50, height: 50, f: 'px', b: 'px'}
          }" -->
          <!-- <gmap-info-window 
            :opened="rqs[index].open" 
            @closeclick="closeInfo(index)">
            <div v-html="template"></div>
          </gmap-info-window> -->

        </GmapMarker>
      </GmapMap>
      </b-col>
    </b-row>

    <ModalInfoMap :showModalInfoMap="showModalInfoMap" :truck="truck" @close="showModalInfoMap = false"/>
    <div v-if="showModalInfoMap" class="modal-backdrop fade show"></div>
    
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from '@/constants';
import { mapGetters } from 'vuex'
import {gmapApi} from 'vue2-google-maps'
import ModalInfoMap from './ModalInfoMap'
export default {
  name: "tracking",
  components: { ModalInfoMap },
  data() {
    return {
      center: { lat: -12.0509389, lng: -76.9974641 },
      zoom: 11,
      template: "",
      rqs: [],
      trucks: [],
      truck: {
        requeriments: [{ 
          deposit: {}, 
          deposit_pick: {},
          service: { service_type: {} }
        }]
      },
      showModalInfoMap: false,
      search: ''
    };
  },
  mounted() {

    api.get("/trucks_logged").then(response => {
      this.trucks = response.trucks
    })
  },
  computed:{
    ...mapGetters({
      user: 'user/user'
    }),
    google: gmapApi,
    trucksFiltered(){
      return this.trucks.filter(truck => {
        let condition = true
        if(this.search){
          condition = truck.plate.toLowerCase().includes(this.search.toLowerCase())
        }
        return condition
      })
    }
  },
  methods: {
    showInfo(truck){
      this.showModalInfoMap = true
      this.truck = truck
    },
    // openInfo(rq, index) {
    //   this.template = `
    //     <strong>#RQ:</strong> ${rq.id}<br/>
    //     <strong>Servicio:</strong> ${rq.service.service_type.name}<br/>
    //     <strong>BL/Booking</strong> ${rq.service.doc_number}<br/>
    //     <strong>Placa:</strong> ${rq.truck.plate}<br/>
    //     <strong>Conductor:</strong> ${rq.driver.name} ${rq.driver.last_name}<br/>
    //   `;
    //   this.rqs[index].open = true;
    // },
    closeInfo(index) {
      this.trips[index].open = false;
    }
  },
  sockets: {
    connect(){
      console.log('conectado')
    },
    locationTruckAdmin(truck){
      // console.log(truck)
      const current_truck = this.trucks.find(t => t.id == truck.id)
      const index = this.trucks.findIndex(t => t.id == truck.id)

      if(index > -1){
        // console.log("Actual ", current_truck.plate, current_truck.lat, current_truck.lng)
        // console.log("Nuevo ", truck.plate, truck.lat, truck.lng)
        
        this.trucks.splice(index, 1, truck)
        
        // var deltalat = (truck.lat - current_truck.lat) / 100;
        // var deltalng = (truck.lng - current_truck.lng) / 100;
        // var delay = 30 * .5;
        // let trucks_update = this.trucks
        // for (var i = 0; i < 100; i++) {
        //   (function(ind) {
        //     setTimeout(
        //       function() {
        //         var lat = current_truck.lat
        //         var lng = current_truck.lng
        //         lat += deltalat;
        //         lng += deltalng;
        //         truck.lat = lat
        //         truck.lng = lng
        //         console.log(truck.lat)
        //         trucks_update.splice(index, 1, truck)
        //       }, delay * ind
        //     );
        //   })(i)
        // }
      }
    }
  }
};
</script>